// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"document-location"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M21.75 16.75C21.75 20.0035 18 22.5 18 22.5C18 22.5 14.25 20.0035 14.25 16.75C14.25 14.6789 15.9289 13 18 13C20.0711 13 21.75 14.6789 21.75 16.75Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17.75 17H18.25M21.75 16.75C21.75 20.0035 18 22.5 18 22.5C18 22.5 14.25 20.0035 14.25 16.75C14.25 14.6789 15.9289 13 18 13C20.0711 13 21.75 14.6789 21.75 16.75Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20.5 9.5V2.5L3.5 2.5V21.5H12M8 8H16M8 12H11","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-document-location')
export default class DocumentLocationIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'document-location',
    }
  }
}
